import React from 'react'

const VoitekCall = ({color}) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="30"
            enableBackground="new 0 0 512 512"
            viewBox="0 0 128 128"
        >
            <circle
                cx="64"
                cy="64"
                r="64"
                fill={color ? color : "#51AB51"}
                data-name="Circle Grid"
                data-original="#ef5261"
            ></circle>
            <path
                fill="#eeefee"
                d="M57.831 70.1c8.79 8.79 17.405 12.356 20.508 9.253l4.261-4.26a7.516 7.516 0 0110.629 0l9.566 9.566a7.516 7.516 0 010 10.629l-7.453 7.453c-7.042 7.042-27.87-2.358-47.832-22.319C37.534 70.441 30.991 61.04 26.762 52.2s-5.086-16.091-1.567-19.61l7.453-7.453a7.516 7.516 0 0110.629 0l9.566 9.563a7.516 7.516 0 010 10.629L48.579 49.6c-3.103 3.1.462 11.714 9.252 20.5z"
                data-original="#eeefee"
            ></path>
        </svg>
    )
}

export default VoitekCall